import CoreAccordion from './CoreAccordion';

export { type CoreAccordionProps } from './CoreAccordion';
export default CoreAccordion;
